// extracted by mini-css-extract-plugin
export var button = "_f4-4";
export var hasDarkBackground = "_f4-7";
export var hasLightBackground = "_f4-6";
export var iconWrapper = "_f4-0";
export var large = "_f4-2";
export var medium = "_f4-1";
export var small = "_f4-5";
export var xsmall = "_f4-3";